/** Replaces the whole set of sections marked for reevaluation on a version; `[]` clears it. */
class UpdateDocumentTemplateVersionSections {
	constructor(
		public readonly organizationId: number,
		public readonly versionId: number,
		public readonly reevaluationSectionKeys: readonly string[],
	) {
		Object.freeze(this);
	}

	// `organizationId` and `versionId` are route identifiers: neither is echoed in the request body.
	toJSON(): Record<string, unknown> {
		return { reevaluationSectionKeys: this.reevaluationSectionKeys };
	}
}

export default UpdateDocumentTemplateVersionSections;
